import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

export const useStyles = () => ({
  typographyStyle: {
    textDecoration: 'underline',
    textDecorationColor: COLORS.black.main,
    textUnderlineOffset: '4px',
    fontSize: '16px',
  },
  customStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minWidth: '150px',
    gap: '10px',
  },
  containerStyle: {
    padding: '10px 10px 0px 0px',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '0 20px',
    },
  },
  phoneWrapperStyle: { display: 'none' },
});
